module.exports = __webpack_public_path__ + "media/icons/minus-05d759f0.png";